import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import { Typography } from '@raisin/components-lib';

export const BanksHeroWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  minHeight: 370,
  padding: theme.spacing(10, 0),
  background: 'linear-gradient(90deg, rgb(43, 43, 43) 0%, rgb(43, 105, 159) 100%)',
}));

export const BanksHeroHeading = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.body1.fontWeight,
  marginBottom: theme.spacing(8),
  color: theme.palette.white.main,

  [theme.breakpoints.down('lg')]: {
    fontSize: theme.typography.h3.fontSize,
  },
}));

export const BanksHeroDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.white.main,

  [theme.breakpoints.down('lg')]: {
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.h5.lineHeight,
  },
}));

export const ContainerBankHero = styled(Container)(({ theme }) => ({
  padding: theme.spacing(0, 6),
}));
